import { render, staticRenderFns } from "./CaseProblems.vue?vue&type=template&id=bfb7cd3a&"
import script from "./CaseProblems.vue?vue&type=script&lang=js&"
export * from "./CaseProblems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports